<script>
import {imagesLoad} from '@/util/assetLoadUtil';

import lImg from '@/assets/img/decoration/l_moon.svg';
import tImg from '@/assets/img/decoration/t_libra.svg';
import oImg from '@/assets/img/decoration/o_sun.svg';

export default {
  name: 'hoverDesign',
  components: {
  },
  data() {
    return {
      texts: [],
      ready: false,
    };
  },
  props: {
    titleText: {
      type: String,
      required: true,
    },
    titleType: { // moon, libra, sun,
      type: String,
      default: 'moon',
    }
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.ready = false;
      this.texts =  this.titleText.split('');
      await imagesLoad([
        lImg, tImg, oImg 
      ]);
      setTimeout(()=> {
        this.ready = true;
      }, 1);
    }
  }
};
</script>

<template>
  <div class="page-title wf-gothicfont" :title="titleText" :class="titleType">
    <span
      v-for="(t, i) in texts" :key="i"
      :style="{'animation-duration': `${1 + (i * 0.2)}s`}"
    >{{t}}</span>
  </div>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  // ページタイトル -----------------------------------------
  .page-title {
    width: 95%;
    height: 100px;
    font-size: 2.8em;
    text-align: left;
    position: relative;
    @include bg;
    transform-origin: 0 0;
    animation: animeTitle 1s ease-out 0s 1;
    &.moon {
      line-height: 95px;
      padding-left: 45px;
      background-image: url(../assets/img/decoration/l_moon.svg);
    }
    &.libra {
      line-height: 135px;
      padding-left: 85px;
      background-image: url(../assets/img/decoration/t_libra.svg);
    }
    &.sun {
      line-height: 105px;
      padding-left: 75px;
      background-image: url(../assets/img/decoration/o_sun.svg);
    }
    span {
      display: inline-block;
      position: relative;
      animation: animeText 1s ease-out 0s 1;
    }
  }

  @keyframes animeTitle {
    0%{
      opacity: 0;
      background-position: 3% 0%;
      transform: rotate(-15deg);
    }
    100%{
      opacity: 1;
      background-position: 0% 0%;
      transform: rotate(0deg);
    }
  }
  @keyframes animeText {
    0%{
      left: 70px;
      top: 30px;
      color: $textColor;
      transform: rotate(15deg);
    }
    50%{color: $textColor;}
    51%{color: $accentColor2;}
    56%{color: $accentColor2;}
    57%{color: $textColor;}


    93%{color: $textColor;}
    94%{color: $accentColor2;}
    99%{color: $accentColor2;}
    100%{
      left: 0px;
      top: 0px;
      color: $textColor;
      transform: rotate(0deg);
    }
  }
</style>
